import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { QueryGetActiveOrdersArgs } from '@/gql/graphql';
import type { PaginatedDeliveryOrderResponse } from '@/models/gourmet';

// Fragments
import './fragments/multiOrderPartialFragment';

export const getActiveOrders = async (variables: QueryGetActiveOrdersArgs) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables,
    query: graphql(`
      query getActiveOrders(
        $driverName: String
        $driverPhone: String
        $pagination: PaginationInputType
        $service: String
        $storeName: String
      ) {
        getActiveOrders(
          driverName: $driverName
          driverPhone: $driverPhone
          pagination: $pagination
          service: $service
          storeName: $storeName
        ) {
          ...MultiOrderPartialFragment
        }
      }
    `),
  });

  return response.data.getActiveOrders as PaginatedDeliveryOrderResponse;
};
